import MainBar from './MainBar';

export default MainBar